import { render, staticRenderFns } from "./CardDataForm.vue?vue&type=template&id=55253610&scoped=true&"
import script from "./CardDataForm.vue?vue&type=script&lang=js&"
export * from "./CardDataForm.vue?vue&type=script&lang=js&"
import style0 from "./CardDataForm.vue?vue&type=style&index=0&id=55253610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55253610",
  null
  
)

export default component.exports